// i18n area 'backups' — locale et-EE (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.et-EE.meta.json.
import type { enUS } from './backups'

export const etEE: typeof enUS = {
  ckpt: {
    contents: 'Võtab vastu',
    contentsHint:
      'Mis siia maanduda tohib. „Checkpointid“ on klastri seadistus, „Andmete varukoopiad“ on virtuaalmasinate omad: kaks lugemist liituvad, üks sihtkoht võib vastu võtta mõlemad.',
    content: { checkpoints: 'Checkpointid', backups: 'Andmete varukoopiad' },
    destinationsTitle: 'Varunduse sihtkohad',
    checkpointsTitle: 'Checkpointid',
    restoreTitle: 'Taastamine',
    addDestination: 'Lisa sihtkoht',
    addDestinationTitle: 'Lisa varunduse sihtkoht',
    editDestinationTitle: 'Muuda sihtkohta',
    storage: 'Storage',
    storageHint: 'Dir-laadne storage (dir/NFS/CIFS/CephFS) — artefaktid on tavalised failid platvormi nimeruumis.',
    schedule: 'Ajastus',
    scheduleNone: 'Ainult käsitsi',
    scheduleHourly: 'Igatunnine',
    scheduleDaily: 'Igapäevane',
    scheduleWeekly: 'Iganädalane',
    scheduleHour: 'Tund',
    scheduleWeekday: 'Nädalapäev',
    scheduleHint:
      "Ajastatud checkpointidel pole operaatorit, kes masterpassi sisestaks: keystore'i saladused pakitakse kohatäidetena.",
    retention: 'Retention',
    retentionHint:
      'Mitu ajastatud checkpointi alles hoida — sweeper eemaldab loendust vanemad. Käsitsi tehtud ja taaste-eelsed checkpointid jäävad alati alles.',
    paused: 'Pausil',
    pausedHint:
      "Operaatori blackout: kuni paus kestab, ei ajastata ega kärbita selles sihtkohas midagi — nii andmete policy'd kui checkpointid. Käimasolevaid käivitusi ei puututa kunagi.",
    rescan: 'Adopteeri artefaktid uuesti',
    orphanRuns: '{n} orvuks jäänud käivitust',
    orphanRunsHint:
      "Plaanitud käivitused policy'dest, mida sellel sihtkohal enam pole: ükski retention ei valitse neid — kunagi ei loendata ega kärbita — ja ainult käsi kustutab need. tvirt diagnose lääts „backups“ nimetab eemaldatud policy'd.",
    rescanTitle: 'Sihtkoha {name} artefaktide taasadopteerimine',
    rescanHint:
      'Ehitab varukoopiate kataloogi (VM/CT/App) uuesti üles sihtkohas olevate artefaktide manifestidest. Olemasolevaid ridu ei puudutata kunagi; tundmatute poliitikate koopiad jäävad orbudeks (ei kärbita kunagi automaatselt). Samm pärast bootstrap-taastet.',
    masterpassDrWarning:
      'Katastroofistsenaarium: LUKS-kettad tulevad tagasi AINULT checkpointist, millel on masterpass. Ajastatud checkpointid pakivad kohatäited — tehke perioodiliselt käsitsi checkpoint masterpassiga.',
    policy: {
      title: "Andmete varukoopiate policy'd",
      hint: "Nimelised policy'd: millised objektid (kind, sildid, scope'id), kui tihti, millal käivitus tohib alata ja mitu koopiat hoida. Värbamise žest jääb objekti omanikule: sildid antakse tema enda scope'is.",
      add: 'Lisa policy',
      column: "Andme-policy'd",
      name: 'Nimi',
      nameHint:
        'Policy silt, kordumatu sihtkoha piires. Käivitused järgivad policy püsivat id-d: ümbernimetamine on tasuta; kustutamine jätab tema käivitused orvuks (enam ei loendata ega kärbita).',
      kindLocked: 'Olemasoleva policy objektiperet ei saa muuta: loo uus policy.',
      kindLabel: 'Objektid',
      kind: { vm: 'Virtuaalmasinad', ct: 'Konteinerid', app: 'Rakendused' },
      tags: 'Sildivalik',
      tagsHint:
        "Komadega eraldatud tag=väärtus paarid, AND-seosega. Tühjad sildid ja scope'id ei vali midagi — mitte kunagi „kõike“.",
      scopes: "Scope'id",
      scopesHint: "Scope'i teed (alampuud), komadega eraldatud, omavahel OR-seosega.",
      windowStart: 'Aken alates',
      windowEnd: 'Aken kuni',
      windowHint:
        'Täitmisaken (HH:MM, kohalik aeg; algus pärast lõppu läheb üle kesköö). See piirab ainult ALGUST: käivitust, mis sellest üle venib, ei tapeta kunagi.',
      mode: 'Režiim',
      modeHint: 'Inkrementaalne ratsutab seeriaperekonnal; katkenud seeria degradeerub fulliks, öeldud päevikus.',
      modeFull: 'Full',
      modeIncremental: 'Inkrementaalne',
      requireQuiesce: "Nõua quiesce'i (guest agent)",
      paused: 'Policy pausil',
      retentionNone: 'Hoia kõik',
      retentionCount: 'Arv',
      retentionGfs: 'GFS-rõngad',
      gfs: {
        keepLast: 'Viimased',
        daily: 'Igapäevased',
        weekly: 'Iganädalased',
        monthly: 'Igakuised',
        yearly: 'Iga-aastased'
      },
      gfsHint:
        'Iga rõnga jaoks hoitakse viimase N perioodi igaühe uusim varukoopia. Hoitud varukoopia hoiab elus kogu oma ahela — mitte kunagi baasi koos orbudega.',
      lastRun: 'Viimane käivitus',
      neverRan: 'pole kunagi käivitunud'
    },
    lastCheckpoint: 'Viimane checkpoint',
    neverRun: 'Pole kunagi tehtud',
    createNow: 'Loo checkpoint',
    createNowTitle: 'Loo checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      "Kaitseb keystore'i saladuste väärtusi (argon2id → AES-256-GCM, väärtuse kaupa). Seda ei salvestata kunagi: hoia see alles — ilma selleta annab taastamine päris saladuste asemel kohatäited.",
    masterpassEmptyHint: 'Jäta tühjaks, et saladuste asemel pakkida selged kohatäited.',
    createStarted: 'Checkpointi loomine käib…',
    destinationInUseError: "Sihtkohas '{name}' on veel checkpointid — kustuta need esmalt.",
    origin: 'Päritolu',
    originManual: 'käsitsi',
    originSchedule: 'ajastatud',
    originPreRestore: 'taaste-eelne',
    originPreChange: 'enne muudatust',
    preChangeRetention: 'Muudatuse-eelsed checkpointid',
    preChangeRetentionHint:
      'Tühi = välja lülitatud. Esimene konfiguratsioonikirjutus pärast vaikuseperioodi külmutab siia eelneva seisu (päritolu „enne muudatust“); uusimad säilitatakse kuni arvuni — oma, kärbitav retentsioon.',
    diffTitle: 'Muudatuste eelvaade',
    diffFailed: 'Eelvaade ebaõnnestus',
    diffRetry: 'Proovi uuesti',
    diffCounts: '{changed} muutub · {missing} luuakse · {extra} üleliigset · {equal} identset',
    diffChanged: 'muutub',
    diffMissing: 'loodaks',
    diffExtra: 'kustutataks',
    diffJsonb: 'jsonb-viiteid ei saa enne rakendamist kontrollida',
    diffSecret: 'pitseeritud väljad, võrreldamatud',
    diffMore: 'veel {n}…',
    diffNeeded: 'Käivitus aktiveerub, kui eelvaade peegeldab valikut.',
    phase: 'Olek',
    phaseRunning: 'töötab',
    phaseComplete: 'valmis',
    phaseError: 'viga',
    secrets: 'Saladused',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'kohatäited',
    size: 'Suurus',
    created: 'Loodud',
    destination: 'Sihtkoht',
    download: 'Laadi alla .tvbk',
    deleteCheckpoint: 'Kustuta checkpoint',
    noCheckpoints: 'Ühtegi checkpointi veel pole — loo üks mõnest sihtkohast.',

    // Voor #156 (dialoogi standard): backupi kirje täielik lugemispind —
    // üksikasjaread nende väljade jaoks, mida tabel kunagi ei näidanud.
    families: 'Perekonnad',
    generation: 'Generatsioon',
    completedAt: 'Lõpetatud',
    errorDetail: 'Vea üksikasjad',
    manifest: 'Manifest',
    restoreHint:
      'Laadi üles .tvbk artefakt: explorer näitab, mida see sisaldab, seejärel valid, mida ja kuidas taastada.',
    uploadFile: 'Laadi üles .tvbk fail',
    uploading: 'Üleslaadimine…',
    uploadFailed: 'Artefakti ei õnnestunud avada',
    explorerTitle: 'Checkpointi sisu',
    checkpointFrom: 'Klastri {cluster} checkpoint, loodud {when} ({origin}, generatsioon {generation})',
    otherCluster:
      'See checkpoint on loodud TEISES klastris ({cluster}) — klastriülene taastamine tuleb mõnes tulevases voorus.',
    encrypted: 'krüptitud',
    objectsCount: '{n} objekti',
    mode: 'Režiim',
    modeMerge: 'Merge — lepitamine: valitud ridade upsert, midagi ei kustutata',
    modeOverwrite:
      'Overwrite — võidab checkpoint: täielikult valitud perekond asendatakse tervikuna (praegused read, mida checkpointis pole, kaovad)',
    restoreMasterpassHint:
      'Masterpass, millega see checkpoint loodi. Ilma selleta taastatakse krüptitud saladused selgete kohatäidetena.',
    checkMasterpass: 'Kontrolli',
    masterpassOk: 'Masterpass on õige',
    masterpassWrong: 'Masterpass on vale',
    parachuteDestination: 'Langevarju sihtkoht',
    parachuteHint: 'Enne ühegi rea puudutamist loob task siia automaatse taaste-eelse checkpointi.',
    summaryTitle: 'Mis juhtub',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'terve perekond',
    summaryObjects: '{n} valitud objekti',
    confirmHint:
      'Kinnitamiseks sisesta klastri nimi ({name}) — taastamine kirjutab deklareeritud konfiguratsiooni üle.',
    confirmField: 'Klastri nimi',
    startRestore: 'Taasta',
    restoreRunning: 'Taastamine käib…',
    restoreDone: 'Taastamine lõpetatud — reconcilerid koonduvad uuele deklaratsioonile.',
    restoreFailed: 'Taastamine nurjus',
    discard: 'Hülga',
    selectionEmpty: 'Vali vähemalt üks perekond või objekt.'
  },

  backup: {
    intro: {
      title: 'VM-ide ja konteinerite andmete backup',
      subtitle: 'Ehituskivid, mida väline backup-tarkvara kasutab',
      whatItIs:
        "TVirt pakub nelja primitiivi: quiesced snapshot'id, kettapõhine change tracking, kirjutuskaitstud NBD-eksport ja konfiguratsiooni eksport. Neid juhivad Veeam, Bacula, Acronis ja teised omasugused.",
      whatItIsNot:
        'TVirt ei ole backup-toode: ta ei planeeri midagi, ei rakenda retentsiooni ega hoia sinu andmetest mingit arhiivi. Retentsioon, kataloogid ja taastepoliitikad jäävad tarkvarale, mida sa juba kasutad.'
    },
    cbt: {
      title: 'Muudatuste jälgimine',
      colVm: 'VM',
      colDisk: 'Ketas',
      colState: 'Olek',
      colBitmaps: 'Bitmapid',
      colObservedAt: 'Vaadeldud',
      colChangeId: 'Change ID',
      colMechanic: 'Mehhanism',
      stateActive: 'Aktiivne',
      stateInactive: 'Väljas',
      stateInconsistent: 'Ebakõlaline — järgmine varukoopia peab olema täielik',
      stateBroken: 'Ahel katkenud — keela, seejärel luba uue ahelana',
      stateSnapshots: 'Alati sees — delta hetktõmmiste vahel',
      stateUnavailable: 'Sellel kettal pole saadaval',
      mechanic: {
        'qcow2-bitmap': 'qcow2 bitmap',
        'rbd-snapdiff': 'Ceph hetktõmmiste diff',
        'lvm-thin-delta': 'Thin pooli delta',
        none: 'Puudub'
      },
      empty:
        'VM-i kettaid pole. Jälgimist loetakse ketta kaupa: luba see qcow2 kettal või tee hetktõmmiseid rbd/SAN-il.',
      chainBroken: 'Ahel katkenud',
      chainBrokenText:
        'Katkestas {reason}: {bitmaps}. Keela bitmap (ahel on kadunud, järgmine varukoopia on täielik), seejärel luba see uue ahelana.',
      lineages: 'Epohhid',
      epochFrozen: 'külmutatud hetktõmmises {snapshot}',
      epochLost: 'kadunud ({cause})',
      epochRecording: 'salvestab peas',
      milestones: 'Verstapostid (hetktõmmised)',
      enable: 'Luba muudatuste jälgimine',
      disable: 'Keela',
      reset: 'Lähtesta',
      changedAreas: 'Muutunud alad',
      denied: 'Sul puudub õigus sellel VM-il',
      enableTitle: 'Luba muudatuste jälgimine',
      disableTitle: 'Keela muudatuste jälgimine',
      resetTitle: 'Lähtesta bitmap',
      areasTitle: 'Muutunud alad',
      bitmapName: 'Bitmapi nimi',
      bitmapNameHint: 'Oma nimi: tvirt- ja tvbk- kuuluvad platvormile',
      granularity: 'Granulaarsus (baiti)',
      granularityHint: 'Kahe aste; vaikimisi 65536',
      bitmap: 'Bitmap',
      disableHint: 'Eemaldab bitmapi ja kogu selle epohhide ajaloo: järgmine varukoopia peab olema täielik.',
      resetHint: 'Tühjendab bitmapi — uus alus: lähtestamisest vanem change ID pole enam koostatav.',
      areasFrom: 'Hetktõmmisest',
      areasTo: 'Hetktõmmiseni',
      areasRun: 'Arvuta',
      areasResult: '{count} muutunud ala, {bytes}',
      areasEmpty: 'Kahe hetktõmmise vahel pole muutunud alasid',
      areasZero: 'nullid',
      areasMore: 'näidatakse esimesed {shown} {count}-st',
      submit: 'Kinnita',
      error: 'Jälgimistoiming ebaõnnestus'
    },
    exports: {
      title: 'Avatud NBD-ekspordid',
      colVm: 'VM',
      colDisk: 'Ketas',
      colSnapshot: 'Hetktõmmis',
      colBitmap: 'Bitmap',
      colPhase: 'Faas',
      colNode: 'Sõlm',
      colEndpoint: 'Lõpp-punkt',
      colExpires: 'Aegub',
      colCreated: 'Avatud',
      colError: 'Viga',
      phase: {
        preparing: 'Ettevalmistamine',
        ready: 'Valmis',
        closed: 'Suletud',
        error: 'Ebaõnnestus'
      },
      expiresIn: '{minutes} min pärast',
      expired: 'aegunud',
      empty: 'Eksporte pole. Lugemisseanss pakub ühte ketast ühes hetktõmmises NBD-kliendile; kirjutamisseanss täidab peatatud VM-i puutumata ketta. Mõlemad surevad aegumisel.',
      endpointHint: 'TLS klastri CA-ga; ekspordi nimi on pilet — see sureb koos seansiga',
      closeDenied: 'Sul puudub õigus selle VM-i eksporte sulgeda',
      open: 'Ava NBD-eksport',
      openTitle: 'Ava NBD-eksport',
      openDisk: 'Ketas',
      openBitmap: 'Bitmap (valikuline)',
      openBitmapHint:
        'Avaldab selle bitmapi selles hetktõmmises külmutatud epohhi muutunud extentide meta-contextina (ainult qcow2 kettad)',
      openTtl: 'Eluiga (minutit)',
      openSubmit: 'Ava',
      openError: 'Eksporti ei saanud avada',
      colMode: 'Režiim',
      mode: {
        read: 'Lugemine',
        write: 'Kirjutamine'
      },
      caCertificate: 'Klastri CA',
      caCopy: 'Kopeeri PEM',
      caDownload: 'Laadi alla ca-cert.pem',
      caHint: 'Kirjuta PEM faili ca-cert.pem privaatses kaustas ja ühenda nbds://…?tls-certificates=<kaust> (nbdcopy, nbdinfo) või --object tls-creds-x509,dir=<kaust>,endpoint=client (qemu-img) kaudu',
      caAbsent: 'Seanss ei kanna CA-d (PKI puudub)',
      openWrite: 'Ava kirjutamiseksport',
      openWriteTitle: 'Ava kirjutamiseksport',
      openWriteIntro: 'Ketas peab olema puutumata: sündinud tühjana, kunagi kirjutamata, ilma hetktõmmiseta; VM peatatud. Taastamine TÄIDAB ketta, see ei paranda seda. Kuni seanss on avatud, ei käivitu VM, ei tee hetktõmmist, ei kloonu ja ketast ei teisaldata.',
      openWriteSubmit: 'Ava',
      openWriteError: 'Kirjutamiseksporti ei õnnestunud avada',
      openWriteDenied: 'Sul puudub selle VM-i vm.restore.data',
      openWriteStopped: 'Peata VM, et avada kirjutamiseksport',
      fromDescription: 'Loo VM kirjeldusest',
      fromDescriptionTitle: 'Loo VM kirjeldusest',
      fromDescriptionIntro: 'export-vm-meta kirjeldus tuleb tagasi peatatud VM-ina, mille kettad on tühjad ja kirjeldatud geomeetriaga — valmis kirjutamisekspordi jaoks, ketas ketta haaval. Baidid siit läbi ei käi: neid kannab restore-disk (CLI) või varundustoote NBD-klient.',
      fromDescriptionDoc: 'Kirjeldus (JSON)',
      fromDescriptionDocHint: 'Kleebi export-vm-meta dokument või vali fail',
      fromDescriptionFile: 'Vali fail…',
      fromDescriptionInvalid: 'Tekst ei ole JSON-dokument',
      fromDescriptionName: 'Uue VM-i nimi',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Sinu koduscope',
      fromDescriptionStorage: 'Ketaste salvestusruum',
      fromDescriptionStorageHint: 'Iga ketas sünnib siin, salvestusruumi vaikevormingus',
      fromDescriptionMetadataStorage: 'Metaandmete salvestusruum',
      fromDescriptionSameAsStorage: 'Sama mis ketastel',
      fromDescriptionBridge: 'Sild',
      fromDescriptionBridgeHint: 'Ilma silla või võrguta sünnib VM ilma võrgukaartideta',
      fromDescriptionNetwork: 'Loogiline võrk (fabric/võrk)',
      fromDescriptionSubmit: 'Loo',
      fromDescriptionError: 'VM-i ei õnnestunud luua',
      fromDescriptionDone: 'VM loodud: {name}',
      fromDescriptionOpen: 'Ava VM',
      fromDescriptionDenied: 'Sul puudub vm.create',
      fromDescriptionStillRunning: 'Loomine kestab veel: ootame edasi'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'VM-ide andmete varukoopiad',
      titleOnVm: 'Andmete varukoopiad',
      empty:
        "Varukoopiaid pole. Varukoopia viib kettad, UEFI varstore'i ja vTPM oleku sihtkohta ning elab virtuaalmasina üle.",
      colVm: 'VM',
      colCreated: 'Tehtud',
      colPhase: 'Tulem',
      colDestination: 'Sihtkoht',
      colContains: 'Sisu',
      colSize: 'Suurus',
      colOrigin: 'Päritolu',
      colMode: 'Tüüp',
      retentionChip: 'Säilitus',
      retentionHint:
        'Sihtkoha säilitusreegel võib selle varukoopia küsimata kustutada: see sündis ajakavast. Käsitsi tehtud varukoopiaid ei pühita kunagi.',
      policyRemoved: 'Policy eemaldatud: {name}',
      policyRemovedHint:
        "Selle backupi plaaninud policy't enam pole: ükski retention seda ei valitse (kunagi ei kärbita automaatselt) — kustuta see käsitsi, kui seda enam vaja pole.",
      phase: {
        running: 'Käib',
        complete: 'Valmis',
        error: 'Ebaõnnestus'
      },
      origin: {
        manual: 'Käsitsi',
        schedule: 'Ajastatud'
      },
      mode: {
        full: 'Täielik',
        incremental: 'Juurdekasvuline'
      },
      contains: {
        disks: 'Kettad',
        varstore: 'UEFI varstore',
        vtpm: 'vTPM olek',
        snapshots: 'Hetktõmmised'
      },
      vmState: {
        stopped: 'VM välja lülitatud',
        running: 'VM töötab (kuum)'
      },
      artifactClass: { metadata: 'Metaandmed', data: 'Andmed', secret: 'Saladus' },
      detail: {
        tabOverview: 'Ülevaade',
        tabArtefact: 'Artefakt',
        id: 'Identifikaator',
        scope: 'Ulatus',
        vmState: 'VM olek kopeerimise ajal',
        pointInTime: 'Andmete hetk',
        completedAt: 'Lõppes',
        node: 'Kopeerinud sõlm',
        error: 'Viga',
        path: 'Kaust hoidlas',
        checksum: 'manifesti sha256',
        secretsExposed: 'Tundlik materjal avatekstina',
        secretsExposedYes: 'Jah — sihtkoht ei krüpti',
        secretsExposedNo: 'Ei',
        baseBackup: 'Baasvarukoopia',
        tabManifest: 'Manifest',
        manifestHint:
          "Artefakti avatud register: üks fail rea kohta koos oma sha256-ga. Kausta saab kontrollida ka ilma TVirtita — piisab qemu-img'ist, tar'ist ja jq'st.",
        manifestEmpty: 'Manifest ei loetle faile.',
        manifestError: 'Manifesti ei saa lugeda',
        colEntry: 'Fail',
        colClass: 'Klass',
        colSha: 'sha256'
      },
      create: {
        action: 'Tee varukoopia nüüd',
        title: 'Tee varukoopia nüüd',
        submit: 'Käivita varundamine',
        destination: 'Sihtkoht',
        destinationHint: 'Ainult sihtkohad, mis varukoopiaid vastu võtavad.',
        noDestinations: 'Ükski sihtkoht ei võta varukoopiaid vastu: looge see menüüs Süsteem → Checkpoints.',
        contentsHint:
          'Kaasa sõidavad kõik kettad, UEFI varstore ja vTPM olek. Viimased kaks ongi mõte: pitseeritud külaline peab uuesti käivituma.',
        error: 'Varundamine ei käivitunud',
        stillRunning: 'Varundamine käib veel — kopeerimine jätkub ka siis, kui sulgete.',
        vmRunning:
          'Masin on {phase}: varundus vajab stabiilset VM-i — välja lülitatud külma koopia jaoks, töötav kuuma jaoks.'
      },
      restore: {
        action: 'Taasta',
        title: 'Taasta',
        intro: 'Taastamine on pöördumatu. Valige, kuhu andmed naasevad: uude masinasse või algse peale.',
        modeNewVm: 'Taasta UUDE VM-i',
        modeNewVmHint:
          'Ei puuduta midagi olemasolevat — selle valikuga varukoopiat kontrollitakse. Uus identifikaator ja värskelt vermitud MAC-aadressid.',
        modeOver: 'Kirjuta algne VM üle',
        modeOverHint: 'Hävitab siht-VM-i praegused andmed, ilma tagasiteeta. Masin peab olema välja lülitatud.',
        newName: 'Uue VM-i nimi',
        newNameHint: 'See peab olema siht-ulatuses vaba.',
        storage: 'Ketaste hoidla',
        storageHint: 'Kohustuslik: manifest märgib ketta suuruse ja vormingu, mitte kunagi hoidlat, kus see asus.',
        metadataStorage: "Hoidla varstore'i ja vTPM jaoks",
        metadataStorageHint: 'Kuhu maanduvad UEFI identiteet ja vTPM olek.',
        sameAsStorage: 'Sama mis ketastel',
        bridge: 'Hosti bridge',
        bridgeHint:
          "Iga kirja pandud võrgukaart naaseb sellele bridge'ile uue MAC-iga. Tühjaks jäetuna sünnib VM ilma kaartideta — turvalisem vaikeväärtus.",
        overwriteTitle: 'Olete kirjutamas seda VM-i üle',
        overwriteName: 'Nimi',
        overwriteId: 'Identifikaator',
        overwriteDisks: 'Kettad, mis kirjutatakse üle',
        overwriteNoDisks: 'Kettaid pole.',
        overwriteKeeps:
          'Puutumata jäävad identifikaator, nimi, ulatus, võrgukaardid ja MAC-aadressid: varukoopia on ANDMED, seadistus on checkpoint.',
        confirmField: 'VM-i nimi',
        confirmHint: 'Kinnitamiseks kirjutage {name}.',
        targetLoading: 'Loen siht-VM-i…',
        targetRunning:
          'Siht-VM on {phase}: taastamine kirjutab külalise all olevad baidid üle, seega nõuab seda välja lülitatuna.',
        targetGone: 'Algset VM-i ei saa enam lugeda: alles jääb taastamine uude VM-i.',
        onlyComplete: 'Varukoopia on {phase}: taastada saab ainult valmis varukoopia.',
        submitNewVm: 'Taasta uude VM-i',
        submitOver: 'Kirjuta üle',
        error: 'Taastamine ei käivitunud',
        stillRunning: 'Taastamine käib veel — tervete ketaste kopeerimine võtab aega.'
      }
    },
    guest: {
      title: {
        ct: 'Konteinerite andmevarukoopiad',
        app: "App'ide andmevarukoopiad"
      },
      tabTitle: 'Varukoopiad',
      empty: 'Varukoopiaid pole. Varukoopia viib püsivad andmed sihtkohta ja elab oma objekti üle.',
      colSubject: {
        ct: 'Konteiner',
        app: 'App'
      },
      colCreated: 'Tehtud',
      colPhase: 'Tulemus',
      colDestination: 'Sihtkoht',
      colContains: 'Sisu',
      colSize: 'Suurus',
      colOrigin: 'Päritolu',
      policyRemoved: 'Policy eemaldatud: {name}',
      policyRemovedHint:
        "Selle backupi plaaninud policy't enam pole: ükski retention seda ei valitse (kunagi ei kärbita automaatselt) — kustuta see käsitsi, kui seda enam vaja pole.",
      phase: {
        running: 'Käimas',
        complete: 'Valmis',
        error: 'Ebaõnnestus'
      },
      origin: {
        manual: 'Käsitsi',
        schedule: 'Plaanitud'
      },
      state: {
        stopped: 'Objekt peatatud',
        running: 'Objekt töötab (külmutatud)'
      },
      contains: {
        rootfs: 'Rootfs-puu',
        config: 'Konfiguratsioon',
        volumes: 'Püsivad köited',
        root: 'Püsiv root'
      },
      artifactClass: {
        metadata: 'Metaandmed',
        data: 'Andmed',
        secret: 'Salajane'
      },
      create: {
        action: 'Tee varukoopia kohe',
        title: 'Uus varukoopia',
        submit: 'Käivita varukoopia',
        error: 'Varukoopia ei käivitunud',
        destination: 'Sihtkoht',
        destinationHint: 'Ainult sihtkohad, mis võtavad vastu andmevarukoopiaid.',
        noDestinations: 'Ükski sihtkoht ei võta andmevarukoopiaid vastu: lisage sihtkohale „Andmevarukoopiad“.',
        hint: {
          ct: 'Kaasa rändab kogu rootfs-puu, truult (numbrilised omanikud, xattrid, ACL-id), pluss deklareeritud konfiguratsioon manifestis. Töötav konteiner KÜLMUTATAKSE kogu pakkimise ajaks: crash-consistent koopia, deklareeritud.',
          app: 'Kaasa rändavad AINULT püsivad köited (ja püsiv root), pluss konfiguratsioon manifestis. Efemeersed osad on ratifitseerimisega välistatud ja manifest nimetab neid; salajaseks deklareeritud env-väärtused ei rända.'
        },
        stillRunning: 'Varukoopia veel käimas — tervete puude pakkimine võtab aega.'
      },
      detail: {
        tabOverview: 'Ülevaade',
        tabManifest: 'Manifest',
        id: 'Identifikaator',
        scope: 'Ulatus',
        state: 'Seisund kopeerimisel',
        pointInTime: 'Andmed hetkel',
        completedAt: 'Lõpetatud',
        node: 'Kopeerinud sõlm',
        error: 'Viga',
        path: 'Kaust salvestusruumis',
        checksum: 'manifesti sha256',
        manifestHint:
          'Artefakti indeks: üks kirje faili kohta koos sha256-ga — ilma räsideta on „varukoopia on olemas“ usu küsimus.',
        manifestError: 'Manifesti ei saa lugeda',
        manifestEmpty: 'Manifestis pole artefakte.',
        colEntry: 'Fail',
        colClass: 'Klass',
        colSha: 'sha256',
        excluded: 'Ratifitseerimisega välistatud (ei rända)',
        secretKeys: 'Välja jäetud salajased env-võtmed (#307) — sisestage need pärast taastet uuesti'
      },
      restore: {
        action: 'Taasta',
        title: 'Taaste',
        submit: 'Taasta',
        error: 'Taaste ei käivitunud',
        stillRunning: 'Taaste veel käimas — tervete puude lahtipakkimine võtab aega.',
        onlyComplete: 'Varukoopia on {phase}: taastada saab ainult valmis varukoopiast.',
        asNew: {
          ct: 'UUDE konteinerisse — ei hävita midagi: žest, millega varukoopiat kontrollitakse',
          app: "UUDE App'i — ei hävita midagi: žest, millega varukoopiat kontrollitakse"
        },
        over: {
          ct: 'Lähtekonteineri PEALE — kogu rootfs-puu asendatakse',
          app: "Lähte-App'i PEALE — iga püsiva köite sisu asendatakse"
        },
        name: 'Uue objekti nimi',
        storage: 'Salvestusruum',
        storageHint: 'Kuhu taastatud andmed maanduvad — manifest ei kirjuta kunagi üles kaotatud pooli.',
        storageDeclared: 'Manifestis deklareeritud salvestusruumid',
        bridge: 'Hosti sild',
        bridgeHint:
          'Iga kirja pandud võrgukaart naaseb sellel sillal värske MAC-iga. Tühi = sünnib ühendamata, kõige turvalisem vaikimisi.',
        node: 'Sõlm',
        nodeHint: 'Liige, millel App uuesti sünnib: sõlm on klastri identiteet ega tule kunagi manifestist.',
        secretKeysWarning:
          "Salajaseks deklareeritud env-väärtused varukoopias ei rända: uuesti sündinud koopia tahab neid uuesti sisestatuna (task'i logi nimetab võtmed).",
        overInventory: 'Olete seda objekti üle kirjutamas',
        confirmType: 'Kinnitamiseks trükkige {name}',
        targetGone: 'Lähteobjekti ei saa enam lugeda: taastamine uuena jääb saadavale.',
        targetLoading: 'Sihtobjekti lugemine…',
        targetRunning: 'Sihtobjekt töötab: taaste asendab baidid külalise all ja tahab teda peatatuna.'
      }
    }
  }
}
